<template>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.92 11.745H1.39C0.62 11.745 0 12.375 0 13.135V14.465C0 15.235 0.63 15.855 1.39 15.855H5.92C6.69 15.855 7.31 15.225 7.31 14.465V13.135C7.31 12.365 6.68 11.745 5.92 11.745ZM6 14.455C6 14.505 5.92 14.545 5.92 14.545H1.39L1.3 14.455V13.125L1.39 13.045H5.92L6 13.125V14.455Z"
			fill="#646E87"
		/>
		<path
			d="M14.6 5.93502H10.07C9.3 5.93502 8.68 6.56502 8.68 7.32502V7.34502H4.95L5.39 6.97502C5.66 6.74502 5.7 6.33502 5.47 6.05502C5.24 5.77502 4.83 5.74502 4.55 5.97502L2.96 7.31502L2.82 7.46502C2.67 7.65502 2.61 7.88502 2.64 8.11502C2.67 8.34502 2.79 8.55502 2.95 8.67502L4.55 10.015C4.67 10.115 4.82 10.165 4.97 10.165C5.16 10.165 5.34 10.085 5.47 9.93502C5.7 9.65502 5.66 9.24502 5.39 9.01502L4.95 8.64502H8.68C8.68 9.42502 9.31 10.045 10.07 10.045H14.6C15.37 10.045 15.99 9.41502 15.99 8.65502V7.32502C15.99 6.55502 15.36 5.93502 14.6 5.93502ZM14.69 8.66502L14.6 8.75502H10.07L9.99 8.66502V7.33502C9.99 7.28502 10.07 7.24502 10.07 7.24502H14.6L14.69 7.33502V8.66502Z"
			fill="#646E87"
		/>
		<path
			d="M1.39 4.25502H5.92C6.69 4.25502 7.31 3.62502 7.31 2.86502V1.53502C7.31 0.76502 6.68 0.14502 5.92 0.14502H1.39C0.62 0.14502 0 0.77502 0 1.53502V2.86502C0 3.63502 0.63 4.25502 1.39 4.25502ZM1.3 1.53502L1.39 1.45502H5.92L6 1.53502V2.86502C6 2.91502 5.92 2.95502 5.92 2.95502H1.39L1.3 2.86502V1.53502Z"
			fill="#646E87"
		/>
	</svg>
</template>
<script>
export default { name: 'SubflowsSVG' };
</script>
